import React, { useEffect, useState } from "react";
import AppHeader from "shared-components/Header";
import LeftPanel from "shared-components/LeftPanel";
import Breadcrumb from "shared-components/Breadcrumb";
import { Container, Row, Col } from "react-bootstrap";
import {
  getUserAgent,
  getMemberAccountNo,
  memberNameFormat,
  cacheManager,
  printRenewalInvoiceMenu,
} from "../helpers/util-common";
import { find, isEmpty, get } from "lodash";
import IdentityDelegationBanner from "modules/identityDelegationBanner";
import { IDENTITY_DELEGATION_FLAG, USER_INFO } from "models/common.models";
import { ModuleUrls } from "models";
import WCMSFooter from "shared-components/WCMS/WCMSFooter";
import { getEntitlementListAction } from "./actions/entitlement.action";
import { setSafariAutoFillInfoAction } from "common.actions";
import { useDispatch } from "react-redux";

const Layout = (props) => {
  const { userInfo, children } = props;
  const [entitlementList, setEntitlementList] = useState([]);
  const [memberName, setMemberName] = useState();
  const [demoGraphy, setDemoGraphy] = useState();
  const [customMenu, setCustomMenu] = useState();
  const dispatch = useDispatch();
  const accountNo = getMemberAccountNo();
  const identityDelegation = cacheManager.getItem(USER_INFO)
    ? get(JSON.parse(cacheManager.getItem(USER_INFO)), IDENTITY_DELEGATION_FLAG)
    : null;
  const featureFlag = cacheManager.getItem("flagFeature")
    ? JSON.parse(cacheManager.getItem("flagFeature"))
    : null;

  useEffect(() => {
    let isRenew = null;
    if (!isEmpty(entitlementList?.menuList)) {
      const membershipMenuList = find(entitlementList.menuList, {
        title: "Membership",
      });
      isRenew = find(membershipMenuList.child, { title: "Renew Membership" });
    }
    if (!isEmpty(isRenew)) {
      setCustomMenu(printRenewalInvoiceMenu());
    }

    let demoGraphyData =
      entitlementList?.otherInfo && entitlementList?.otherInfo.demographyDetails
        ? entitlementList?.otherInfo.demographyDetails
        : {};
    setDemoGraphy(demoGraphyData);
    if (get(demoGraphyData, "FirstName")) {
      setMemberName(
        memberNameFormat(
          get(demoGraphyData, "FirstName"),
          get(demoGraphyData, "MiddleName"),
          get(demoGraphyData, "LastName"),
          1
        )
      );
    } else {
      setMemberName(
        memberNameFormat(
          get(userInfo, "firstName"),
          "",
          get(userInfo, "lastName"),
          1
        )
      );
    }
  }, [entitlementList]);

  useEffect(() => {
    const { name } = getUserAgent();
    if (name === "Safari") {
      setSafariAutoFillInfoAction(dispatch, true);
    }
    if (accountNo)
      getEntitlementListAction(accountNo, dispatch, (response) => {
        setEntitlementList(response);
      });
  }, []);

  return (
    <div className="app">
      <AppHeader userInfo={userInfo} entitlementList={entitlementList} />
      {identityDelegation && (
        <IdentityDelegationBanner
          {...identityDelegation}
          accountNo={accountNo}
        />
      )}
      <Container>
        <Row>
          <Col xs={12} md={3} className="leftPanel">
            <LeftPanel
              {...props}
              memberHost={process.env.REACT_APP_MEETINGAPP_URL}
              customMenu={customMenu}
              isMemberApp={true}
              activePath={ModuleUrls.MyCommmittees}
              entitlementList={entitlementList}
              isMainMenu={true}
              hideUserDetail={false}
              getMenuMappedList={() => void 0}
              userObj={{
                accountNumber: getMemberAccountNo(),
                memberType: get(userInfo, "MembershipTypeId"),
                name: memberName,
                email: get(demoGraphy, "Email")
                  ? get(demoGraphy, "Email")
                  : get(userInfo, "email"),
                organizationName: get(demoGraphy, "CompanyName")
                  ? get(demoGraphy, "CompanyName")
                  : get(demoGraphy, "FacilityName")
                  ? get(demoGraphy, "FacilityName")
                  : null,
              }}
              globalLinksURL={{
                profile: process.env.REACT_APP_GLOBAL_PROFILE_URL,
                membership: ModuleUrls.MyASTM,
                campus: process.env.REACT_APP_GLOBAL_ASTM_CAMPUS_URL,
                meetingsSymposia:
                  process.env.REACT_APP_GLOBAL_MEETING_SYMPOSIA_URL,
                orders: process.env.REACT_APP_GLOBAL_ORDERS_URL,
                compass: process.env.REACT_APP_GLOBAL_COMPASS_URL,
                tracker: process.env.REACT_APP_GLOBAL_TRACKERS_URL,
              }}
              featureFlag={featureFlag}
            />
          </Col>
          <Col xs={12} md={9}>
            <Breadcrumb />
            {children}
          </Col>
        </Row>
      </Container>
      <WCMSFooter />
    </div>
  );
};

export default Layout;
